import { PAYMENT_V2_ENDPOINT_V2 } from "@/components/Pricing/v2/constants.pricing";
import { TCloudAPIResponse } from "@/types/app";
import axios from "axios";

interface AddPaymentOption {
  token: string;
}

type TResponse = TCloudAPIResponse<string>;

const APIURL = `${PAYMENT_V2_ENDPOINT_V2}/user/customer-portal`;

export async function addPaymentMethod(
  option: AddPaymentOption,
): Promise<string> {
  try {
    const response = await axios.get(APIURL, {
      headers: {
        Authorization: option.token,
      },
    });

    const data = response.data as TResponse;
    return data.data;
  } catch (error: any) {
    console.error("Error getting customer portal URL:", error);
    throw error;
  }
}
